import React from 'react'
import './style.css'
const index = () => {
    let frameStyle={
        width: '100%',
        marginBottom: '3rem',
        border: '0',
        transform: 'scale(1)',
        overflow: 'hidden'
    }
  return (
    <div className="component-desc">
            <h2 className="heading">Grid</h2>
            <div className="description">Grid is used to divide the layout into rows and colums easily.</div>
            <div className="divider"></div>
            <h4 className="heading">Two items in a Grid</h4>
            <div class="grid grid--col-2">
                <div style={{height:'100px',background:'gold'}}></div>
                <div style={{height:'100px',background:'dodgerblue'}}></div>
            </div>

            <div className="carbon-container">
                <iframe
                    src="https://carbon.now.sh/embed?bg=rgba%28248%2C231%2C28%2C1%29&t=blackboard&wt=none&l=javascript&width=680&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=%253Cdiv%2520class%253D%2522grid%2520grid--col-2%2522%253E%250A%2509%253Cdiv%253E%253C%252Fdiv%253E%250A%2509%253Cdiv%253E%253C%252Fdiv%253E%250A%253C%252Fdiv%253E"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>

            <div className="divider"></div>
            <h4 className="heading">Three items in a Grid</h4>
            <div class="grid grid--col-3">
                <div style={{height:'100px',background:'gold'}}></div>
                <div style={{height:'100px',background:'dodgerblue'}}></div>
                <div style={{height:'100px',background:'tomato'}}></div>
            </div>

            <div className="carbon-container">
                <iframe
                    src="https://carbon.now.sh/embed?bg=rgba%28248%2C231%2C28%2C1%29&t=blackboard&wt=none&l=javascript&width=680&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=%253Cdiv%2520class%253D%2522grid%2520grid--col-3%2522%253E%250A%2509%253Cdiv%2520style%253D%257B%257Bheight%253A%27100px%27%252Cbackground%253A%27gold%27%257D%257D%253E%253C%252Fdiv%253E%250A%2520%2520%2520%2520%253Cdiv%2520style%253D%257B%257Bheight%253A%27100px%27%252Cbackground%253A%27dodgerblue%27%257D%257D%253E%253C%252Fdiv%253E%250A%2520%2520%2520%2520%253Cdiv%2520style%253D%257B%257Bheight%253A%27100px%27%252Cbackground%253A%27tomato%27%257D%257D%253E%253C%252Fdiv%253E%250A%253C%252Fdiv%253E"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>
        </div>
  )
}

export default index